module.exports = __webpack_public_path__ + "static/img/card-templates_off.fc1f5c9b.png";